import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet, useNavigate } from 'react-router-dom'

import { useValueContext, ValueContext } from 'contexts'
import { HomeStore } from 'stores'

const HomeLayout = observer(() => {
  const navigate = useNavigate()
  const babyStore = useValueContext()
  const [store] = useState(() => new HomeStore(babyStore.getBabyLastEvents, navigate))

  return (
    <ValueContext.Provider value={{ babyStore, homeStore: store }}>
      <Outlet />
    </ValueContext.Provider>
  )
})

export default HomeLayout
